import { useNavigate, Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft, ArrowRight, Search, ScrollText, KeyRound } from 'lucide-react';
import { useAdminGrants } from '../hooks';

const adminLinks = [
  {
    label: 'User Lookup',
    description: "Search for a user's game states",
    icon: Search,
    path: '/a/arche_dfe_game_state/admin/users',
  },
  {
    label: 'Plugin Grants',
    description: 'Approve plugin-arche keyword/task access requests',
    icon: KeyRound,
    path: '/a/arche_dfe_game_state/admin/grants',
    showsPendingCount: true,
  },
  {
    label: 'Audit Log',
    description: 'Browse all mutation audit entries',
    icon: ScrollText,
    path: '/a/arche_dfe_game_state/admin/audit',
  },
];

export function AdminDashboardPage() {
  const navigate = useNavigate();
  // Pending-grant count for the Plugin Grants tile badge. The hook fetches
  // a single page (default 50) but `total` reflects the full set.
  const { total: pendingGrantsTotal } = useAdminGrants({ reviewStatus: 'pending', limit: 1 });

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <div>
        <Link
          to="/a/arche_dfe_game_state"
          className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-2"
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back to Game State
        </Link>
        <h1 className="text-2xl font-semibold">Admin Dashboard</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manage DFE game state data across all users
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {adminLinks.map((link) => {
          const Icon = link.icon;
          return (
            <Card
              key={link.path}
              className="hover:bg-muted/50 transition-colors cursor-pointer"
              onClick={() => navigate(link.path)}
            >
              <CardContent className="flex items-center justify-between py-6">
                <div className="flex items-center gap-3">
                  <Icon className="h-5 w-5 text-muted-foreground" />
                  <div>
                    <div className="flex items-center gap-2">
                      <p className="font-medium">{link.label}</p>
                      {link.showsPendingCount && pendingGrantsTotal > 0 && (
                        <Badge variant="secondary">{pendingGrantsTotal} pending</Badge>
                      )}
                    </div>
                    <p className="text-sm text-muted-foreground">{link.description}</p>
                  </div>
                </div>
                <ArrowRight className="h-4 w-4 text-muted-foreground" />
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
